import { render, staticRenderFns } from "./DashboardPadrillos.vue?vue&type=template&id=64f867bc&scoped=true"
import script from "./DashboardPadrillos.vue?vue&type=script&lang=js"
export * from "./DashboardPadrillos.vue?vue&type=script&lang=js"
import style0 from "./DashboardPadrillos.vue?vue&type=style&index=0&id=64f867bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f867bc",
  null
  
)

export default component.exports